import type { IconProps } from './../../models/icon';

export function UserIcon({ width = 24, height = 24, className }: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_336_1007)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1.85715C9.47523 1.85715 7.42853 3.90385 7.42853 6.42858C7.42853 8.95331 9.47523 11 12 11C14.5247 11 16.5714 8.95331 16.5714 6.42858C16.5714 3.90385 14.5247 1.85715 12 1.85715ZM5.42853 6.42858C5.42853 2.79928 8.37066 -0.142853 12 -0.142853C15.6293 -0.142853 18.5714 2.79928 18.5714 6.42858C18.5714 10.0579 15.6293 13 12 13C8.37066 13 5.42853 10.0579 5.42853 6.42858Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.85389 16.7441C6.92906 15.2303 9.43135 14.4146 12 14.4146C14.5686 14.4146 17.0709 15.2303 19.1461 16.7441C21.2213 18.2579 22.7621 20.3915 23.5465 22.8375C23.6441 23.1417 23.5904 23.4741 23.4022 23.7322C23.2139 23.9902 22.9137 24.1429 22.5943 24.1429H1.40571C1.08628 24.1429 0.78607 23.9902 0.59782 23.7322C0.409569 23.4741 0.355931 23.1417 0.453474 22.8375C1.23786 20.3915 2.77871 18.2579 4.85389 16.7441ZM12 16.4146C9.85502 16.4146 7.76546 17.0957 6.03256 18.3598C4.68026 19.3463 3.59969 20.648 2.87899 22.1429H21.121C20.4003 20.648 19.3197 19.3463 17.9674 18.3598C16.2345 17.0957 14.145 16.4146 12 16.4146Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
